module.exports = __webpack_public_path__ + "assets/4862e0477cf2980e0f5f0ab167dc853e.png";